import { TweenMax, Quint } from 'gsap';
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Transfer } from '../../models/transfer';
import { EventTypes } from '../../../shared/EventTypes';
import { TransfersOmniService } from '../transfers-omni.service';
import { TransfersOmniEventType } from '../transfers-omni.event.type';

@Component({
	selector: 'app-omni-security-check',
	templateUrl: './security-check.component.html',
	styleUrls: ['./security-check.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class SecurityCheckComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited = false;
	@Input() transferData: Transfer;

	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	public form: FormGroup;
	private view = '[data-component="security-check"]';

	active = false;

	constructor(private formBuilder: FormBuilder, private transferOmniService: TransfersOmniService) {
		this.form = formBuilder.group({
			'securityAnswer': ['1', Validators.required]
		});
	}

	ngOnInit() {
		AppEventDispatcher.listen(TransfersOmniEventType.STEPS.SECURITY_CHECK, data => {

			if (data.show) {
				this.active = true;
				this.setForm.emit(this.form);
				this.show();
			} else {
				this.hide();
			}
		});

		AppEventDispatcher.listen(TransfersOmniEventType.TRANSFER.CONFIRM, () => {
			this.hide();
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(TransfersOmniEventType.STEPS.SECURITY_CHECK);
		AppEventDispatcher.removeListener(TransfersOmniEventType.TRANSFER.CONFIRM);
	}

	setTransferData() {
		this.transferData.securityAnswer = this.form.controls.securityAnswer.value;
	}

	show() {

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			AppEventDispatcher.dispatch(EventTypes.BALANCE, { show: false });

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
		});

	}

	hide() {

		this.preload(true);

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		this.transferOmniService.confirmTransfer(this.transferData.id, this.transferData.transferType, this.transferData.favoredRemember).subscribe( data => {

			this.transferData.message = data.Mensagem;
			this.transferData.success = data.Sucesso;

			if (time > 3) {
				this.preload(false);
				this.hideAfterSend();
			}	else {
				TweenMax.delayedCall(3 - time, () => {
					this.preload(false, 3 - time);
					this.hideAfterSend();
				});
			}
			clearInterval(timeLoader);

		}, data => {
			AppEventDispatcher.dispatch(TransfersOmniEventType.ERROR, {step: TransfersOmniEventType.STEPS.SECURITY_CHECK});

			if (time > 3) {
				this.preload(false);
			}	else {
				TweenMax.delayedCall(3 - time, () => {
					this.preload(false, 3 - time);
				});
			}
			clearInterval(timeLoader);

		});

	}

	hideAfterSend() {

		TweenMax.delayedCall(1, () => {

			AppEventDispatcher.dispatch(TransfersOmniEventType.STEPS.TRANSFER_RESULT, {show: true});

			TweenMax.to(this.view, 2.8, { left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});

		});

	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight();
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="transfers-other-banks"] .content', show: active, delay: delay});
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transfers-omni/security-check/security-check.component.ts